import { PButton, PFlexItem, PFlex } from '@porsche-design-system/components-react'
import React from 'react'

import ContentHeader from '../../../components/Content/Header/ContentHeader'
import { ReportingContext } from '../../../utils/Context/ReportingContext'
import CollapsibleFilterApplication from '../../Collapsible/Filter/CollapsibleFilterApplication'
import Calendar from '../Calendar/Calendar'

import { PortalContext, UserRole } from '../../../utils/PortalContext'

import styles from './actionbar.module.css'

type Props = {
  appList: any
}

const ActionBar: React.FC<Props> = ({ appList }) => {
  const period = 90
  const start = new Date(new Date(new Date().setDate(new Date().getDate() - period)).setHours(0, 0, 0, 0))
  const end = new Date(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59, 59, 999))
  const {
    setStartDate,
    setEndDate,
    setDatePeriod,
    setResetParams,
    setChosenDepartment,
    setChosenApplication,
    setApplicationButton,
    setContentHeader,
    setOpenSubApps,
    setOpenFilterMenu,
    setShowSingleRatings,
    setFilter,
    singleRatings,
    setSingleRatings,
    chosenApplication,
    chosenDepartment,
    startDate,
    endDate
  } = React.useContext(ReportingContext)
  const { userRole, setLoading } = React.useContext(PortalContext)

  const [showResetButton, setShowResetButton] = React.useState(false)

  React.useEffect(() => {
    if (startDate !== null && startDate.toDateString() !== start.toDateString()) {
      setShowResetButton(true)
    } else if (endDate !== null && endDate.toDateString() !== end.toDateString()) {
      setShowResetButton(true)
    } else if (chosenDepartment !== '') {
      setShowResetButton(true)
    } else if (chosenApplication !== '') {
      setShowResetButton(true)
    } else {
      setShowResetButton(false)
    }
  }, [startDate, endDate, chosenDepartment, chosenApplication])

  const resetFilter = () => {
    setLoading(true)
    setStartDate(start)
    setEndDate(end)
    setDatePeriod(period)
    setResetParams(true)
    setChosenDepartment('')
    setChosenApplication('')
    setSingleRatings(singleRatings)
    //setDepartmentButton('Alle Abteilungen')
    setApplicationButton('Alle Applikationen')
    setContentHeader(userRole === UserRole.ApplicationManager ? 'Alle Applikationen' : 'Alle Abteilungen')
    //setShowDepartmentList(true)
    //setShowTeamDepartmentList(false)
    setShowResetButton(false)
    setOpenSubApps(false)
    setOpenFilterMenu(false)
    if (userRole === UserRole.KeyUser || userRole === UserRole.Manager) {
      setShowSingleRatings(false)
      //setShowDepartmentList(true)
    }
    setFilter({
      from: start.getTime(),
      to: end.getTime(),
      app: [],
      subApp: [],
      module: [],
      includeAppHierarchy: true,
      department: [],
      includedepartmenthierarchy: true,
      responsible: ''
    })
    setLoading(false)
  }
  return (
    <ContentHeader>
      <PFlexItem>
        <Calendar />
      </PFlexItem>
{/*       {(userRole === UserRole.Manager || userRole === UserRole.KeyUser) && departmentList.length > 0 && (
        <PFlexItem>
          <CollapsibleFilterDepartment data={departmentList} placeholderText='Abteilung suchen' />
        </PFlexItem>
      )} */}
      {appList.length > 0 && (
        <PFlexItem>
          <CollapsibleFilterApplication data={appList} placeholderText='Applikation suchen' />
        </PFlexItem>
      )}

      {showResetButton && (
        <PFlex className={styles.resetBtn}>
          <PFlexItem>
            <PButton className={styles.buttonHeader} icon='close' variant='tertiary' onClick={resetFilter}>
              Auswahl zurücksetzen
            </PButton>
          </PFlexItem>
        </PFlex>
      )}
    </ContentHeader>
  )
}

export default ActionBar
